<template lang="pug">
  .full-height.container
    .center-vertical
      .empty
        .empty-icon
          img(alt="Vue logo" src="../assets/logo.png" style='width: 150px;')
        p.empty-title.h5 OS-m Admin
        p.empty-subtitle O OS-m Admin é responsável pelo gerenciamento de serviços e notificações
        code v{{version}}
        .divider.py-2
        small.empty-subtitle Desenvolvido por
        p.empty-title.h5 Paliari Engenharia de Software
        a(href='http://paliari.com', target='_blank') paliari.com
</template>

<script>
import { version } from '../../package'

export default {
  props: { collapsed: Boolean },
  data() {
    return { version }
  },
}
</script>
